import { ColumnDef } from '@tanstack/angular-table';
import { DepositsHistory } from '../interfaces/deposits-history.interface';
import { TableDateCellComponent } from '@core/components/table/table-date-cell/table-date-cell.component';
import { TableColorCellComponent } from '@core/components/table/table-color-cell/table-color-cell.component';
import { flexRenderComponent } from '@tanstack/angular-table';
import { ClipboardService } from '@core/services/clipboard.service';
import { CostComponent } from '@core/components/cost/cost.component';

interface Props {
  copy: typeof ClipboardService.prototype.copy;
}
export const depositsHistoryTableConfig = (
  props: Props
): ColumnDef<DepositsHistory>[] => [
  {
    accessorFn: (row) => row.type,
    id: 'type',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Type',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.id,
    id: 'id',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'ID',
      };
    },
    cell: (cell) => {
      const id = cell.getValue() as string;

      return flexRenderComponent(TableColorCellComponent, {
        inputs: {
          value: id,
          cursor: 'pointer',
          maxWidth: 150,
        },
        outputs: {
          handleClick: () => {
            props.copy(id, 'ID copied!');
          },
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.offerid,
    id: 'offerid',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Offer ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.value,
    id: 'value',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Value',
      };
    },
    cell: (cell) => {
      const value = cell.getValue() as number;
      return flexRenderComponent(CostComponent, {
        inputs: {
          cost: value,
          balanceType: 'skins',
          gap: 4,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.date,
    id: 'date',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Time',
      };
    },
    cell: (cell) => {
      const value = cell.getValue() as number;
      return flexRenderComponent(TableDateCellComponent, {
        inputs: {
          value,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.status,
    id: 'status',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Status',
      };
    },
    cell: (cell) => {
      const statuses = {
        processed: 'var(--yellow)',
        cancelled: 'var(--red)',
        accepted: 'var(--green)',
        failed: 'var(--red)',
        declined: 'var(--red)',
        pending: 'var(--purple)',
      };

      const status = cell.getValue() as string;
      return flexRenderComponent(TableColorCellComponent, {
        inputs: {
          color: statuses[status as keyof typeof statuses],
          value: status,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.special,
    id: 'special',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Additional Data',
      };
    },
    cell: (cell) => {
      const special = cell.getValue() as string;
      return special || '-';
    },
    enableSorting: true,
  },
];
